/**
 * Application Constants (Signup)
 * Simplified constants for the signup/onboarding app
 */

// API Configuration
export const API_CONFIG = {
  REQUEST_TIMEOUT: 10000,
  MAX_RETRIES: 3,
  CONFIG_ENDPOINT: 'http://localhost:3001/api/config',
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  TIMEOUT: 'Request timed out. Please try again.',
} as const;

// Validation Rules
export const VALIDATION_RULES = {
  PASSWORD_MIN_LENGTH: 8,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  USERNAME_MIN_LENGTH: 1,
} as const;

// Log Levels for debugging
export enum LOG_LEVEL {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
}

export const CURRENT_LOG_LEVEL = (
  process.env.NODE_ENV === 'production'
    ? LOG_LEVEL.WARN
    : LOG_LEVEL.DEBUG
) as LOG_LEVEL;
